import type { CityConfig } from "../city-template/types";

export const milfordNhConfig: CityConfig = {
  city: "Milford",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "milford-nh",
  route: "/cities/milford-nh",
  title: "Emergency Passport Milford, NH | Fast Passport Renewal & Expedited Help",
  metaDescription: "Emergency passport and expedited passport services in Milford, NH — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Hillsborough County and Souhegan Valley travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Milford, NH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Milford and Souhegan Valley travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Milford%20New%20Hampshire%20historic%20downtown%20view%20with%20the%20iconic%20Milford%20Oval%20town%20common%2C%20charming%20New%20England%20architecture%20with%20white%20clapboard%20buildings%20and%20colonial%20storefronts%2C%20the%20Souhegan%20River%20flowing%20through%20the%20town%20center%2C%20warm%20autumn%20light%20with%20golden%20and%20orange%20foliage%2C%20peaceful%20small-town%20atmosphere%20with%20tree-lined%20streets%2C%20no%20visible%20text%20or%20people%2C%20photorealistic%20landscape%20with%20warm%20earth%20tones%20and%20soft%20blue%20sky%2C%20inviting%20southern%20New%20Hampshire%20town%20scene&width=1800&height=700&seq=milford-nh-hero-001&orientation=landscape",
  heroImageAlt: "Milford New Hampshire historic downtown with the iconic Milford Oval and Souhegan River",
  geoPosition: "42.8354;-71.6489",
  geoPlacename: "Milford, New Hampshire",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "10 Causeway St Suite 247, Boston, MA 02222",
    distance: "Located in downtown Boston — approximately 55–70 minutes from Milford via NH-101 and I-93",
  },
  nearbyCitiesZips: [
    { name: "Milford", zips: "03055" },
    { name: "Amherst", zips: "03031" },
    { name: "Wilton", zips: "03086" },
    { name: "Mont Vernon", zips: "03057" },
    { name: "Brookline", zips: "03033" },
    { name: "Hollis", zips: "03049" },
    { name: "Merrimack", zips: "03054" },
    { name: "Nashua", zips: "03060–03064" },
    { name: "Bedford", zips: "03110" },
    { name: "Manchester", zips: "03101–03111" },
    { name: "Goffstown", zips: "03045" },
    { name: "New Boston", zips: "03070" },
    { name: "Lyndeborough", zips: "03082" },
    { name: "Temple", zips: "03084" },
    { name: "New Ipswich", zips: "03071" },
    { name: "Greenville", zips: "03048" },
    { name: "Peterborough", zips: "03458" },
    { name: "Jaffrey", zips: "03452" },
    { name: "Rindge", zips: "03461" },
    { name: "Hillsborough", zips: "03244" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Souhegan Valley departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Nashua", route: "/cities/nashua" },
    { name: "Merrimack", route: "/cities/merrimack" },
    { name: "Manchester", route: "/manchester" },
    { name: "Amherst", route: "/cities/nashua" },
    { name: "Bedford", route: "/manchester" },
    { name: "Goffstown", route: "/cities/goffstown" },
    { name: "Hollis", route: "/cities/nashua" },
    { name: "Keene", route: "/cities/keene" },
  ],
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeNote: "Fast Passport Center serves Milford remotely via secure courier. We do not have a walk-in office in Milford — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Souhegan Valley travelers.",
  fpcOfficeDistance: "Serving all of Hillsborough and Cheshire Counties",
  serviceAreaIntro: "From the historic Milford Oval to the Souhegan River corridor, from the Amherst border to the Mont Vernon hills — Fast Passport Center serves the entire Milford community. We regularly help travelers from Amherst, Wilton, Mont Vernon, and Brookline get their passports fast.",
  nearbyCitiesIntro: "We serve all Milford neighborhoods and nearby Souhegan Valley cities including Amherst, Wilton, Mont Vernon, Brookline, Hollis, Merrimack, Nashua, Bedford, Manchester, Goffstown, New Boston, and Peterborough. If you are in the greater Milford area, we have you covered.",
  howItWorksIntro: "Most Milford travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency.",
  mistakesIntro: "With Manchester-Boston Regional Airport (MHT) just 25 minutes away, Souhegan Valley travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Milford and Souhegan Valley travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Milford? Here are the most common ones we hear from Souhegan Valley travelers.",
  statePageRoute: "/states/new-hampshire",
  statePageName: "New Hampshire",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Milford international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Lisa H.",
      location: "Milford, NH",
      rating: 5,
      text: "My son needed a passport for a school trip to France. The child passport process seemed overwhelming, but Fast Passport Center guided us through every step. Had it in 5 days.",
      service: "Child Passport",
    },
    {
      name: "James P.",
      location: "Amherst, NH",
      rating: 5,
      text: "Business trip to London came up suddenly. Applied Monday and had my passport Wednesday evening. Their courier service is the real deal — no gimmicks, just fast results.",
      service: "Emergency Passport",
    },
    {
      name: "Karen W.",
      location: "Wilton, NH",
      rating: 5,
      text: "Renewed my passport for a Caribbean cruise. The process was so smooth I barely had to think about it. Documents arrived, reviewed, and back in my hands in under a week.",
      service: "Passport Renewal",
    },
    {
      name: "Mark D.",
      location: "Mont Vernon, NH",
      rating: 5,
      text: "Lost my passport two weeks before a family reunion in Ireland. I was panicking but Fast Passport Center handled everything. Replacement arrived in 3 days. Forever grateful.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "milford-nh-1",
      name: "Milford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10 Wason Rd",
      city: "Milford",
      state: "NH",
      zip: "03055",
      phone: "(603) 673-2961",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.5 miles from downtown Milford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Milford. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "milford-nh-2",
      name: "Amherst Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "19 Main St",
      city: "Amherst",
      state: "NH",
      zip: "03031",
      phone: "(603) 673-2921",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "4 miles from Milford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for eastern Milford and Amherst residents. Limited hours — book appointments well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "milford-nh-3",
      name: "Nashua Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10 Main St",
      city: "Nashua",
      state: "NH",
      zip: "03060",
      phone: "(603) 882-4704",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles from Milford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Large facility with extended hours. Photo services available. Book appointments well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "milford-nh-4",
      name: "Merrimack Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Continental Blvd",
      city: "Merrimack",
      state: "NH",
      zip: "03054",
      phone: "(603) 424-4224",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "8 miles from Milford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for southern Hillsborough County residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "milford-nh-5",
      name: "Wilton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10 Main St",
      city: "Wilton",
      state: "NH",
      zip: "03086",
      phone: "(603) 654-2141",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "3 miles from Milford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves western Milford and Wilton residents. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "milford-nh-6",
      name: "Nashua City Clerk",
      type: "City Clerk Passport Acceptance",
      address: "229 Main St",
      city: "Nashua",
      state: "NH",
      zip: "03060",
      phone: "(603) 589-3010",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "12 miles from Milford",
      website: "https://www.nashuanh.gov/",
      websiteLabel: "Nashua City Clerk",
      notes: "Major municipal facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Milford photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Hillsborough County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Milford applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Milford families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Milford travelers often assume standard processing will be fine. It takes 6–13 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Milford or Nashua." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Milford address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Milford before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Milford for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most Souhegan Valley travelers." },
    { q: "How fast can I renew my passport in Milford?", a: "Fast Passport Center offers fast passport renewal in Milford in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. We can expedite your passport renewal in Milford in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Milford?", a: "Same-day passport appointments are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Milford residents." },
    { q: "Can I expedite a child passport in Milford?", a: "Yes. Fast Passport Center expedites child passports in Milford for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Milford with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Milford?", a: "With Fast Passport Center's emergency courier service, Milford travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to visit the Boston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Milford?", a: "Popular options include the Milford Post Office (03055), Amherst Post Office (03031), Nashua Post Office (03060), Merrimack Post Office (03054), and Nashua City Clerk (03060). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Milford?", a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option." },
    { q: "What if I live in a nearby town like Amherst or Wilton?", a: "We serve all of the Souhegan Valley including Amherst, Wilton, Mont Vernon, Brookline, Hollis, Merrimack, Nashua, Bedford, Manchester, and Goffstown. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Milford?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Milford", address: "10 Wason Rd, Milford, NH 03055", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Milford", address: "303 Nashua St, Milford, NH 03055", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Nashua", address: "77 Main St, Nashua, NH 03060", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "UPS Store — Nashua", address: "10 Main St, Nashua, NH 03060", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — Amherst", address: "124 NH-101, Amherst, NH 03031", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Milford", address: "5 Wason Rd, Milford, NH 03055", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Postal Annex — Milford", address: "10 Wason Rd, Milford, NH 03055", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM" },
    { name: "Costco — Nashua", address: "71 Front St, Nashua, NH 03060", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM" },
  ],
  dmvLocations: [
    { name: "DMV — Milford", address: "4 Meadow Rd, Milford, NH 03055", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID and driver's license renewals. Passport-ready photo services available. Online appointment booking.", featured: true },
    { name: "DMV — Nashua", address: "33 Main St, Nashua, NH 03060", hours: "Mon–Fri: 8AM–5PM", note: "Passport-ready photo services available. Appointment required.", featured: false },
    { name: "DMV — Manchester", address: "23 Hazard Ave, Manchester, NH 03109", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID processing. Walk-ins limited — book online first.", featured: false },
    { name: "DMV — Merrimack", address: "1 Continental Blvd, Merrimack, NH 03054", hours: "Mon–Fri: 8AM–5PM", note: "Full-service center for southern New Hampshire residents.", featured: true },
  ],
  airports: [
    { code: "MHT", name: "Manchester-Boston Regional Airport", distance: "25 miles from Milford", address: "1 Airport Rd, Manchester, NH 03103", note: "Closest major commercial airport for Milford travelers. International flights to Canada and Europe. Major domestic hub.", flightUrl: "https://www.flymanchester.com/", flightLabel: "MHT Flight Info", featured: true },
    { code: "BOS", name: "Boston Logan International Airport", distance: "65 miles from Milford", address: "1 Harborside Dr, Boston, MA 02128", note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via Route 3.", flightUrl: "https://www.massport.com/logan-airport", flightLabel: "Logan Airport", featured: false },
    { code: "CON", name: "Concord Municipal Airport", distance: "30 miles from Milford", address: "71 Airport Rd, Concord, NH 03301", note: "Regional airport for general aviation. Charter and private flights available.", flightUrl: "https://www.concordairport.org/", flightLabel: "Concord Airport", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth & Death Certificates", desc: "Order certified New Hampshire birth and death certificates from the NH Division of Vital Records in Concord — online, by mail, or in person.", url: "https://www.sos.nh.gov/records-management/vital-records" },
    { icon: "ri-hearts-line", label: "Marriage Records", desc: "Request certified marriage certificates from the Milford Town Clerk. Required for name change passport applications.", url: "https://www.milfordnh.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decrees", desc: "Obtain certified divorce records through the Hillsborough County Superior Court. Required for name change passport corrections.", url: "https://www.courts.state.nh.us/courtlocations/hillsborough-south-district.htm" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside New Hampshire, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};